/* global axios */
import ApiClient from '../ApiClient';

// Kho ảnh marketing CHUNG cho cả tài khoản — không tách theo trang. Ảnh gốc
// nằm ở server mình; bản trên Pancake chỉ là bản sao để gửi,
// backend tự lo — xem `app/services/bonboz/kho_anh_pancake.rb`.
class KhoAnhAPI extends ApiClient {
  constructor() {
    super('bonboz/anh_mkts', { accountScoped: true });
  }

  // Trả về một TRANG ảnh, không phải cả kho: trang Bonboz Clinic có 344 tấm.
  // `sapXep`: moi_nhat | cu_nhat | ten_az | ten_za. Khoa la thi server tu ve
  // mac dinh, xem AnhMktsController::SAP_XEP.
  danhSach({ thuMuc, tuKhoa, trang, yeuThich, sapXep } = {}) {
    return axios.get(this.url, {
      params: {
        thu_muc: thuMuc || undefined,
        tu_khoa: tuKhoa || undefined,
        yeu_thich: yeuThich ? 1 : undefined,
        sap_xep: sapXep || undefined,
        trang: trang || 1,
      },
    });
  }

  // multipart vì có tệp; đừng đặt Content-Type tay, để trình duyệt tự sinh
  // boundary — thiếu boundary là Rails không đọc được tệp.
  taiLen({ tep, ten, thuMucId }) {
    const form = new FormData();
    form.append('tep', tep);
    if (ten) form.append('ten', ten);
    if (thuMucId) form.append('thu_muc_id', thuMucId);
    return axios.post(this.url, form);
  }

  // Sửa tên, ghim — cùng một đường. Thư mục đi qua `chuyen`.
  sua({ id, ten, yeuThich }) {
    const than = {};
    if (ten !== undefined) than.ten = ten;
    if (yeuThich !== undefined) than.yeu_thich = yeuThich;
    return axios.patch(`${this.url}/${id}`, than);
  }

  xoa({ id }) {
    return axios.delete(`${this.url}/${id}`);
  }

  xoaNhieu({ ids }) {
    return axios.post(`${this.url}/xoa_nhieu`, { ids });
  }

  // `kieu`: them mot thu muc nua, bo mot thu muc, hay thay sach bang mot cai.
  // Mot tam nam duoc nhieu thu muc nen "chuyen" khong con mot nghia duy nhat.
  chuyen({ ids, thuMucId, kieu }) {
    return axios.post(`${this.url}/chuyen`, {
      ids,
      thu_muc_id: thuMucId || undefined,
      kieu: kieu || 'thay',
    });
  }

  taoThuMuc({ ten }) {
    return axios.post(`${this.baseUrl()}/bonboz/thu_muc_anhs`, {
      ten,
    });
  }

  suaThuMuc({ id, ten }) {
    return axios.patch(`${this.baseUrl()}/bonboz/thu_muc_anhs/${id}`, {
      ten,
    });
  }

  xoaThuMuc({ id }) {
    return axios.delete(`${this.baseUrl()}/bonboz/thu_muc_anhs/${id}`);
  }
}

export default new KhoAnhAPI();
